module.exports = __webpack_public_path__ + "img/google-earth-national-treasures.f608f0df.jpg";